import {
  FETCH_ADV,
} from '../mutation-types'

const initialState = {
  home: [],     // 轮播图
  city: [],     // 热门城市
  feature: [],  // 专题广告
  custom: [],   // 定制旅行达人分享广告
}

const mutations = {
  [FETCH_ADV](state, ads) {
    state.home = ads.filter(ad => ad.adPosition === 1)
    state.city = ads.filter(ad => ad.adPosition === 7)
    state.feature = ads.filter(ad => ad.adPosition === 8)
    state.custom = ads.filter(ad => ad.adPosition === 14)
  },
}

export default {
  state: initialState,
  mutations,
}



// WEBPACK FOOTER //
// ./client/vuex/modules/adv.js